import React, { Component } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import './prof.css'

export default class Prof extends Component {

  render() {
    const description1 = '三度の飯より大きなオッパイが好きだった管理人が、とあるグラドルをキッカケに巨尻と太腿にハマってしまい、気付けば恵体のデカ尻を漁っています。本サイトではチン先に響く作品やセクシー女優・グラビアアイドルに関する駄文を淡々と書き綴っています。'
    //const description2 = '蜜井とわ、前田優希、七草ちとせ、佐山愛、立川理恵、中村知恵、安齋らら、凪ひかる、鷲尾めい、みなと羽琉、大島あいる、恵けい、庵ひめか、西條るり、恋渕ももな、小梅えな、ももい理乃、深田ナナ、松坂みるく、水原みその、小西みか、千歳りあ、さくら悠、杏美月、水咲あかね、若月みいな、深美せりな、羽生ありさ、清塚那奈、有岡みう、青山菜々、橘優花、西川りおん、吉川あいみ、中山ふみか、菜月アンナ、椿織さとみ、推川ゆうり、神宮寺ナオ、田中ねね、桃園怜奈、桃果あかり'
    //const description3 = '西田麻衣、篠崎愛、滝沢乃南、星名美津紀、都丸紗也華、岸明日香、紗綾、相澤仁美、東雲うみ、ちとせよしの、天木じゅん、青木裕子、未梨一花、原つむぎ、やなぱい、原幹恵、彼方美紅、永瀬永茉、柳いろは、鈴木ふみ奈、池田愛恵里、野田彩加、小泉麻耶、高崎聖子、工藤唯'
    return (
      <div className='prof'>
        <p className='heading'>プロフィール</p>
        <div className='prof_contents'>
          <div className='prof_img'>
            <StaticImage
              className="bio-avatar"
              layout="fixed"
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/prof-icon.png"
              width={110}
              height={110}
              style={{ borderRadius: "50%", zIndex: "1", border: "solid 2px #d3d3d3" }}
              alt="Profile picture"
            />
          </div>
          <p className='profile_name'>
            <a href="https://twitter.com/dekahon0822" target="_blank" rel="noreferrer">デカ尻マニア＠オッパイ星人の手記</a>
          </p>
          <p className='prof_description'>{description1}</p>
          {/*
          <br/>
          <p>好きなセクシー女優</p>
          <p className='prof_description'>{description2}</p>
          <br/>
          <p>好きなグラビアアイドル</p>
          <p className='prof_description'>{description3}</p>
          */}
        </div>
      </div>
    )
  }
}